module.exports = __webpack_public_path__ + "img/bg-20260618.jpg";